//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
export default {
  components: {
    DialogsComponent: DialogsComponent,
    PaginationVue: PaginationVue
  },
  data: function data() {
    return {
      domains: [],
      domain_aux: {},
      credentials: [],
      maintenance: [],
      DIALOG_DOMAIN: "dialog_domain",
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      tipo: '',
      test: [],
      selectOrganization: []
    };
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getDomains: function getDomains() {
      var _this = this;
      domainService.get_all().then(function (response) {
        _this.domains = response.data;
        _this.pagination.total = response.data.length;
        _this.currentPage = 1;
        console.log("orgs", _this.domains);
      });
    },
    openDomain: function openDomain(item, tipo) {
      var _this2 = this;
      if (!item) {
        this.credentials = {};
        this.domain_aux = {};
        this.maintenance = {
          tableau_config: {
            has_access_function: false
          },
          powerbi_config: {
            has_access_function: false
          },
          datastudio_config: {
            has_access_function: false
          },
          bigquery_config: {
            has_access_function: true
          }
        };
        this.$refs[this.DIALOG_DOMAIN].onOpen();
      } else {
        this.domain_aux = Object.assign({}, item);
        this.credentials = item.credentials;
        console.log("maintenance_payload", item);
        domainService.get_maintenance(item).then(function (response) {
          if (response.success === true) {
            _this2.maintenance = Object.assign({}, response.data);
            if (!_this2.maintenance.tableau_config) _this2.maintenance.tableau_config = {
              has_access_function: false
            };
            if (!_this2.maintenance.powerbi_config) _this2.maintenance.powerbi_config = {
              has_access_function: false
            };
            if (!_this2.maintenance.datastudio_config) _this2.maintenance.datastudio_config = {
              has_access_function: false
            };
            if (!_this2.maintenance.bigquery_config) _this2.maintenance.bigquery_config = {
              has_access_function: true
            };
            if (!_this2.maintenance.flags) _this2.maintenance.flags = {};
            console.log("maintenance", _this2.maintenance);
          }
        });
        console.log(this.domain_aux);
        this.$refs[this.DIALOG_DOMAIN].onOpen();
      }
      this.tipo = tipo;
    },
    getOrganizations: function getOrganizations() {
      var _this3 = this;
      domainService.getOrganizations().then(function (response) {
        var orgs = response.data;
        orgs.forEach(function (org) {
          _this3.selectOrganization.push(org);
        });
      });
    },
    updateDomain: function updateDomain() {
      var _this4 = this;
      var formElement = this.$refs.form;
      console.log("form:", formElement.validate());
      if (!formElement.validate()) return;
      if (this.tipo == "crear") {
        if (this.selectOrganization.includes(this.domain_aux.domain)) {
          tasks.toast.error("This organization already exists");
          return;
        }
      }
      console.log("asd");
      var cred = {
        "client_email": this.credentials.client_email,
        "project_id": this.credentials.project_id,
        "type": this.credentials.type
      };
      this.domain_aux.credentials = cred;
      var data = {
        "domain": this.domain_aux,
        "maintenance": this.maintenance
      };
      console.log("sending:", data);
      domainService.add_update_domain(data).then(function (response) {
        if (response.success === true) {
          _this4.$refs[_this4.DIALOG_DOMAIN].onClose();
          tasks.toast.success("Actualizado correctamente");
          _this4.getDomains();
        }
      }, function (err) {
        tasks.toast.warning("Error");
      });
    }
  },
  created: function created() {
    this.getDomains();
    this.getOrganizations();
  },
  computed: {
    headers: function headers() {
      return [{
        value: 'domain',
        text: this.traductor('filtros.organization')
      }, {
        value: 'alias',
        text: "Alias"
      }, {
        value: 'actions',
        text: "Actions"
      }];
    },
    readonly: function readonly() {
      return this.tipo === 'ver';
    }
  }
};